import React from 'react';
import {
  Checkbox,
  Header,
  Label,
  Loader,
} from 'semantic-ui-react';

const BooleanFacet = ({
  category,
  code,
  facetConfig,
  facetKey,
  facet,
  filter,
  handleFilterUpdate,
  isLoading,
  canUpdate,
}) => {
  const selectedValuesCount = () => {
    const trueFacet = facet.filter((facetValue) => facetValue.value === true)[0];
    return trueFacet ? trueFacet.count : 0;
  };

  const isChecked = () => filter[0] === true;

  const toggleSelected = () => {
    if (!canUpdate) return;

    const isSelected = !filter[0];
    const newFilter = isSelected ? [true] : [];

    handleFilterUpdate(facetKey, newFilter);
  };

  const checkboxId = `facet_boolean_${category}_${code}_${facetConfig.name}`;

  return (
    <>
      <Header as="h4">
        {isLoading && (<Loader active inline size="tiny" />)}
        <Checkbox
          onChange={() => toggleSelected()}
          id={checkboxId}
          label={(
            <label
              htmlFor={checkboxId}
            >
              {facetConfig.label}
              {!isLoading && (
                <Label circular size="mini">
                  { selectedValuesCount() }
                </Label>
              )}
            </label>
          )}
          checked={isChecked()}
          disabled={!canUpdate}
        />
      </Header>
    </>
  );
};

export default BooleanFacet;
